import {
  Fragment,
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { ReservationCardPsyalive } from '../ReservationCardPsyalive'
import { useStyles } from './styles'
import type { IReservation } from './types'
import { ReservationListSkeleton } from './ReservationListSkeleton'
import { convertStringIntoDateArray } from '@/utils/date'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { getReservationAttendances } from '../../my-calls-services'
import { Text } from '@conexasaude/conexa-hero'
import { useReservationConsultationContext } from '../../contexts/consultationReservationContext'
import CancelledReservationModal from '@/modules/Attendance/submodules/Immediate/components/modals/CancelledReservationModal'
import { pluralizeWord } from '@/utils/string'

const ReservationList: FunctionComponent = () => {
  const [reservationsAttendance, setReservationsAttendance] = useState<
    IReservation[]
  >([])
  const { setReservationConsultationData } = useReservationConsultationContext()
  const styles = useStyles()
  const { user } = useAuthContext()

  const handleReservationAttendanceData = useCallback(async () => {
    const reservationsAttendances = await getReservationAttendances()

    setReservationsAttendance(reservationsAttendances)
    setReservationConsultationData(reservationsAttendances)
  }, [setReservationConsultationData])

  useEffect(() => {
    handleReservationAttendanceData()
  }, [handleReservationAttendanceData])
  return (
    <Fragment>
      <Text variant="headingLarge" css={styles.title}>
        Confirme suas Reservas
      </Text>
      <Text renderAs="p">
        Você tem {reservationsAttendance?.length || 0}{' '}
        {pluralizeWord('horário', 'horários', reservationsAttendance?.length)}{' '}
        {pluralizeWord(
          'reservado',
          'reservados',
          reservationsAttendance?.length,
        )}
        {''} para confirmar
      </Text>
      <div css={styles.consultationCard}>
        {reservationsAttendance?.map((reservations: IReservation) => {
          return (
            <div
              key={reservations?.idAtendimento}
              css={styles.consultationCard}
              onClick={() => {
                setReservationConsultationData({
                  ...reservations,
                })
              }}
            >
              <ReservationCardPsyalive
                readOnly
                professionalId={reservations?.idProfissional}
                professionalName={reservations?.nomeProfissional}
                professionalPicture={reservations?.urlFoto}
                specialty={reservations?.especialidade}
                id={reservations?.idAtendimento}
                appointmentDate={convertStringIntoDateArray(
                  reservations?.dataAtendimentoFmt?.toString() ||
                    '00/00/0000 00:00',
                )}
                email={user?.email}
                cellphone={user?.cellphone}
                token={reservations?.token}
                appointmentDateFormat={reservations?.dataAtendimentoFmt}
              />
            </div>
          )
        })}
      </div>
      <CancelledReservationModal />
    </Fragment>
  )
}

export { ReservationList, ReservationListSkeleton }
